export const DYNAMIC_TEMPLATE_ID = "dynamic_template"
export const DYNAMIC_TEMPLATE_LIST_ID = "dynamic_list"
export const TODO_ITEM_TEMPLATE_PLACEHOLDER = "###TITLE####"
export const TODO_ITEM_JOIN_UPON = ""
